import { Container, Card, Box, styled } from '@mui/material';
import Logo from 'src/components/LogoSign';
import { Outlet } from 'react-router';

const TopWrapper = styled(Box)(
  () => `
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  flex: 1;
  padding: 10px;
`
);

const AuthLayout = () => {
  return (
    <TopWrapper>
      <Container maxWidth="sm">
        <Logo size="lg" />
        <Card
          sx={{
            mt: 3,
            px: 4,
            pt: 5,
            pb: 3,
          }}
        >
          <Outlet />
        </Card>
      </Container>
    </TopWrapper>
  );
};

export default AuthLayout;
